<div class="search-bar">
  <mat-button-toggle-group
    class="search-scope"
    hideSingleSelectionIndicator
    [value]="scope"
    (change)="scope = $event.value"
    aria-label="Search scope"
    >
    <mat-button-toggle value="local" matTooltip="Filter the table on this page">Local</mat-button-toggle>
    <mat-button-toggle value="users" matTooltip="Find a user by email">Users</mat-button-toggle>
    <mat-button-toggle value="assets" matTooltip="Find an asset by name">Assets</mat-button-toggle>
    <mat-button-toggle value="logs" matTooltip="Search manufacturing logs">Logs</mat-button-toggle>
  </mat-button-toggle-group>

  <div class="search-field">
    <mat-icon class="search-icon">search</mat-icon>
    @switch (scope) {
      @case ('local') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="Filter this page"
          [(ngModel)]="message"
          (keyup)="searchLocal($event.target.value)"
          />
      }
      @case ('users') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="User's full email address"
          [(ngModel)]="searchUsersText"
          (keyup.enter)="runSearch()"
          />
      }
      @case ('assets') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="Asset name or partial name (excluding health sensors)"
          [(ngModel)]="assetSearchText"
          (keyup.enter)="runSearch()"
          />
      }
      @case ('logs') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="Unit sequence # or test result"
          [(ngModel)]="searchLogText"
          (keyup.enter)="runSearch()"
          />
      }
    }
    @if (scope === 'local') {
      <mat-checkbox
        class="keep-filter"
        matTooltip="Keep this filter when navigating"
        matTooltipPosition="below"
        [(ngModel)]="saveFilter"
        [ngModelOptions]="{standalone: true}"
        (change)="checkChanged($event)"
        >Keep</mat-checkbox>
    } @else {
      <button mat-flat-button class="search-button" (click)="runSearch()">Search</button>
    }
  </div>
</div>
